import React from 'react';
import styled from 'styled-components';
import { Link } from 'gatsby';

const StyledWrapper = styled.nav`
  display: none;
  ${({ theme }) => theme.mq.desktop} {
    display: flex;
    justify-content: flex-end;
    align-items: center;
    width: 60%;
    z-index: 9990;
  }
`;

const MenuLinksWrapper = styled.ul`
  ${({ theme }) => theme.mq.desktop} {
    display: flex;
    margin: 0 50px;
    padding: 0;
  }
`;

const MenuLink = styled.li`
  ${({ theme }) => theme.mq.desktop} {
    margin-right: 25px;
    list-style: none;
    font-size: ${({ theme }) => theme.font.size.xs};
    font-weight: ${({ theme }) => theme.font.weight.bold};
    font-family: Raleway, sans-serif;
    text-transform: uppercase;
    position: relative;
    white-space: nowrap;
  }
`;

const StyledLink = styled(Link)`
  text-decoration: none;
  color: ${({ theme }) => theme.color.second};
  &:before {
    content: '';
    position: absolute;
    width: 100%;
    height: 2px;
    bottom: -3px;
    left: 0;
    right: 0;
    margin: 0 auto;
    background-color: ${({ theme }) => theme.color.second};
    visibility: hidden;
    transform: scaleX(0);
    transition: all 0.3s ease-in-out 0s;
  }
  &:hover:before {
    visibility: visible;
    transform: scaleX(1);
  }
`;

const menuItems = [
  { name: 'Home', href: 'home' },
  { name: 'inwestycje', href: 'inwestycje' },
  { name: 'o nas', href: 'o_nas' },
  { name: 'oferta', href: 'oferta' },
  { name: 'kontakt', href: 'kontakt' },
];

const DesktopMenu = () => (
  <StyledWrapper>
    <MenuLinksWrapper>
      {menuItems.map(item => (
        <MenuLink key={item.name}>
          <StyledLink aria-label="kliknij element menu" to={`/#${item.href}`}>
            {item.name}
          </StyledLink>
        </MenuLink>
      ))}
    </MenuLinksWrapper>
  </StyledWrapper>
);

export default DesktopMenu;
